import { render, staticRenderFns } from "./SectionSmartPOSTLearnMore.vue?vue&type=template&id=6485049f&scoped=true"
import script from "./SectionSmartPOSTLearnMore.vue?vue&type=script&lang=ts"
export * from "./SectionSmartPOSTLearnMore.vue?vue&type=script&lang=ts"
import style0 from "./SectionSmartPOSTLearnMore.vue?vue&type=style&index=0&id=6485049f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6485049f",
  null
  
)

export default component.exports